import type { DeepPartial } from '@luna/utils-ts';

import type { Trading } from '../../types';

export const tradingConfigSK: DeepPartial<Trading> = {
    applyDateTimeForValidUntilDate: true,
    applyIdAsQueryParam: true,
    applyOrderTypeTooltip: true,
    buyOrderExpectedFeeTypes: ['MAX_FEE', 'ENTRY_FEE'],
    expectedOrderValueFromSignInfo: true,
    includeIsinInQuestionnaireUrl: true,
    orderSignEquivalentValueAttribute: 'equivalentAmountGross',
    orderTypesWithStaticWarning: ['FUND'],
    sellOrderExpectedFeeTypes: ['MAX_FEE', 'EXIT_FEE'],
    shouldLoadTradingDocuments: true,
    showAllMarketPlaces: true,
    showTargetPortfolio: true,
    tradingValidationStrategies: {
        accountNotAllowedToTradeFlag: true,
    },
};
